import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { Gallery, IGallery } from './gallery';

@Injectable({
    providedIn: 'root'
})
export class GalleryService {

    constructor(private http: HttpClient) { }
    private readonly routePrefix: string = '/api/gallery';
    private refresh = new BehaviorSubject<void>(undefined);

    getGalleryInfo$ = this.refresh.pipe(
        switchMap(() => this.getGalleryInfo()),
        shareReplay(1)
    );

    getGallery = (req: IGallery) =>
        this.http.get<Gallery>(this.routePrefix, {
            params: new HttpParams()
                .set('skip', `${req.state.skip?.toString()}`)
                .set('take', `${req.state.take?.toString()}`)
                .set('sortBy', `${req.sortBy.toString()}`)
        })

    private getGalleryInfo = () => this.http.get<{ [key: string]: string; }>(`${this.routePrefix}/galleryinfo`);
}

